<template>
  <!-- 关联预算 -->
  <el-dialog
    title="预算信息"
    :visible.sync="budgetVisible"
    width="800px"
    :before-close="closeBudgetDia"
    :close-on-click-modal="false"
    class="budget-dia"
    append-to-body
  >
    <!-- <div class="search-box">
      <el-form
        :model="listQuery"
        ref="listQuery"
        size="small"
        class="search-form"
      >
        <el-form-item label="商品名称：" label-width="92px" prop="">
          <el-input v-model="listQuery.desc" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label-width="30px">
          <div class="search-btn">
            <div class="btn reset-btn" size="small" @click="handleReset">
              重置
            </div>
            <div class="btn submit-btn" size="small" @click="handleSearch">
              查询
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div> -->
    <div class="list-box">
      <el-table
        max-height="391"
        :data="tableData"
        ref="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="budgetName"
          label="预算名称"
          min-width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="orgShortName"
          label="所属部门"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="budgetAmount"
          label="可用额度"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="originBudgetAmount"
          label="预算总额"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="budgetStatusName"
          label="预算状态"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="budgetEndTime"
          label="有效期"
          min-width="100"
          align="center"
        ></el-table-column>
        <!-- <el-table-column prop="" label="审核状态" min-width="90" align="center">
          <template #default="scope">
            <span>
              {{ scope.row.enquiryAuditStatus ? "审核通过" : "审核拒绝" }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" min-width="90" align="center">
          <template #default="scope">
            <span class="handle-btn" @click="chooseHandle(scope.row)">选择</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, prev, pager, next"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div> -->
    <div slot="footer">
      <div class="default-btn btn" @click="closeBudgetDia">取消</div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/purchase';
export default {
  props: {
    budgetVisible: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      listQuery: {
        orgId: '',
      },
    };
  },
  watch: {
    budgetVisible(newVal) {
      if (newVal) {
        this.listQuery.orgId = this.orgId;
        this.getList(this.listQuery);
      }
    },
  },
  methods: {
    // 选择
    chooseHandle(row) {
      this.$emit('chooseData', row);
      this.$emit('update:budgetVisible', false);
    },
    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.getBudgetListByOrgId(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.tableData = [...res.data];
        }
      });
    },
    closeBudgetDia() {
      this.$emit('update:budgetVisible', false);
      this.$emit('chooseData', { budgetName: '', budgetId: '' });
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep.el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.budget-dia {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      /* .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      } */
    }
  }
  .list-box {
    .handle-btn {
      color: #0064c8;
      cursor: pointer;
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
}
</style>
